(ns ncr.etc.clipboard
  (:require [ncr.manage.preferences :as preferences]
            [uix.core.alpha :as uix]))


; Clipboard reading is fragile and insecure, currently under experimental, candidate to remove
(defn use-read [f]
  ; clipboard API is available only in secure contexts, see https://developer.mozilla.org/en-US/docs/Web/API/Clipboard
  (let [^js clipboard (and (preferences/use-experimental? :read-clipboard?) (.-clipboard js/navigator))]
    (uix/effect!
      (fn []
        (if clipboard
          (when (exists? (.-readText clipboard))
            (-> clipboard (.readText) (.then f) (.catch #(f nil))))
          (f nil)))
      [])))

